import styles from './MaintenanceBanner.module.css';

import {
  useMaintenanceStatus,
  getMaintenanceBannerText,
} from '~/stores/maintenanceStore';

export function MaintenanceBanner() {
  const status = useMaintenanceStatus();

  if (!status?.enabled) {
    return null;
  }

  return (
    <div
      aria-live="polite"
      className={styles.banner}
      data-testid="maintenance-banner"
      role="status"
    >
      <div className={styles.container}>
        <span className={styles.message}>
          MAINTENANCE: {getMaintenanceBannerText(status)}
        </span>
      </div>
    </div>
  );
}
